export default {
  chatIconAriaLabel: '{{teamName}} live chat',
};
